import React from "react";
import { MdMenu } from "react-icons/md";
import Table from "../../common/Table";
import colors from "../../config/colors";
import config from "../../config/config";
import moment from "moment";
import addPrecision from "../../common/addPrecision";
import AppButton from "../../common/AppButton";
import { GiCog } from "react-icons/gi";
import EditSalaryModel from "../expenses/EditSalaryModel";
import { Modal } from "react-bootstrap";

const size = config.iconSize;
const header = [
  { name: "date", title: "Date" },
  { name: "amount", title: "Amount ($)" },
  { name: "comment", title: "Comment" },
];
export default function EmployeeSalaryHistorymodel() {
  const Body = ({ employee, setModel, onDone }) => {
    const EditSalary = EditSalaryModel();
    return (
      <>
        <Table
          normalTable
          header={header}
          data={employee.salary.map((i) => {
            return {
              ...i,
              date: moment(i.date).format("DD/MM/YYYY"),
              amount: addPrecision(i.amount),
            };
          })}
          SideButtons={({ inv }) => {
            return (
              <div className="side-button">
                <AppButton
                  onClick={() => {
                    setModel({
                      visible: true,
                      model: (
                        <React.Fragment>
                          <Modal.Header closeButton>
                            <EditSalary.Header employee={employee} data={inv} />
                          </Modal.Header>
                          <Modal.Body>
                            <EditSalary.Body
                              onDone={onDone}
                              employee={employee}
                              data={inv}
                            />
                          </Modal.Body>
                          <Modal.Footer>
                            <EditSalary.Footer employee={employee} data={inv} />
                          </Modal.Footer>
                        </React.Fragment>
                      ),
                    });
                  }}
                  className="text-primary"
                  leftIcon={<GiCog />}
                />
              </div>
            );
          }}
        />
      </>
    );
  };
  const Header = ({ employee }) => {
    return (
      <span className="d-flex" style={{ alignItems: "center" }}>
        <MdMenu size={size} color={colors.silver} style={{ marginRight: 5 }} />
        <b>Payment Log - {employee.name}</b>
      </span>
    );
  };
  return { Body, Header };
}
